<template>
  <div
    class="columns"
    style="position:relative">
    <div
      v-if="adv.status==='canceled' || !plan.adv_enabled || !adv.promoteur.plan.adv_enabled"
      class="frontdrop"></div>
    <template v-if="has_buyer_space">
      <div class="column is-2">
        <aside class="menu menu--admin">
          <ul class="menu-list has-background-white is-border">
            <li
              :class="{'is-active': panel === 'INVITATION'}"
              @click="panel = 'INVITATION'">
              <a>Invitation</a>
            </li>
            <li
              :class="{'is-active':panel === 'TIMELINE'}"
              @click="panel = 'TIMELINE'">
              <a>FIL D’ACTUALITÉ CLIENT</a>
            </li>
            <li
              :class="{'is-active': panel === 'DOCS'}"
              @click="panel = 'DOCS'">
              <a>DOCUMENTS ET PHOTOS CLIENTS</a>
            </li>
          </ul>
        </aside>
      </div>
      <div class="column">
        <div v-if="program && panel">
          <div
            class="has-background-white is-border"
            v-show="panel === 'INVITATION'">
            <adv-buyer-space-invitation
              @updateBuyerSpaceId="has_buyer_space = false"
              @invitationSent="msg => invitationMessage = msg"
              :valid-buyers="validBuyers"
              :buyers="buyers"
              :adv-pk="advPk"
              :has_buyer_space="has_buyer_space"
              :invitation-message="invitationMessage"
              :buyer-space-buyers="buyerSpaceBuyers"
              :program="program"></adv-buyer-space-invitation>
          </div>
          <div
            class="has-background-white"
            v-show="panel === 'TIMELINE'">
            <adv-buyer-space-timeline
              :timeline="timeline"
              @sliceEvent="sliceEvent"
              @updateTimeline="updateTimeline"></adv-buyer-space-timeline>
          </div>
          <div
            class="has-background-white is-border"
            v-show="panel === 'DOCS'">
            <adv-buyer-space-docs
              :program="program"
              :timeline="timeline"></adv-buyer-space-docs>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="column is-border has-background-white is-paddingless">
        <div
          class="columns is-12 is-gapless is-padding-left-small is-padding-right-small is-vcentered is-minH50p is-marginless"
          :class="!has_buyer_space ? ' has-background-white-ter' : 'has-background-dark'">
          <div class="column is-narrow">
            <div class="is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right">
              <div
                data-tooltip="Contact(s) non valide"
                :class="{'tooltip is-tooltip-right' : !validBuyers}">
                <input
                  id="has_buyer_space"
                  v-model="has_buyer_space"
                  name="has_buyer_space"
                  :disabled="!validBuyers"
                  class="switch is-success is-rounded"
                  type="checkbox">
                <label
                  for="has_buyer_space"
                  :class="!has_buyer_space ? '' : 'has-text-white'"
                  style="font-size: 12.5px"
                  class="is-uppercase">
                  <span v-if="!has_buyer_space">ACTIVER L’ESPACE ACQUÉREUR SUR CE DOSSIER</span>
                  <span v-else>ESPACE ACQUÉREUR ACTIVÉ SUR CE DOSSIER</span>
                  <span
                    v-if="!has_buyer_space"
                    class="is-padding-left-xsmall"
                    v-helper.bottom="'2QAgCWSkUyl10UDMZTofds'">
                    <i class="fal fa-info-circle"></i>
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="is-margin is-border">
          <div class="columns is-gapless">
            <div class="column is-4 is-padding">
              <img
                src="/img/Groupe-14893.svg"
                alt="">
            </div>
            <div class="column is-8 is-padding">
              <div class="title is-2 has-text-weight-medium is-margin-bottom-xsmall">
                Proposez à vos clients une expérience <br>complète de la signature à la livraison
              </div>
              <div class="">
                Valorisez vos procédures et optimisez votre relation client
              </div>
              <div
                class="has-background-dark is-w64p is-margin-top-small"
                style="height: 2px;"></div>
              <p class="is-size-6 is-padding-top-small">
                Ne laissez plus vos clients venir chercher l’information. Vadimm met à leur disposition un espace personnalisé, leur permettant de consulter l’ensemble des documents liés à leur acquisition, mais aussi de suivre l’avancement des travaux. A chaque étape du projet, ils reçoivent une notification mail pour les guider dans les démarches à suivre…
              </p>
              <!-- <p class="is-size-6 is-underline">Détails sur la tarification de ce service</p> -->
              <div class="is-margin-top">
                <a
                  @click="createBuyerSpace()"
                  :disabled="!validBuyers"
                  data-tooltip="Contact(s) non valide"
                  :class="{'tooltip is-tooltip-left' : !validBuyers}"
                  type="button"
                  class="button is-success is-minW380p">
                  ACTIVER LE MODULE SUR CE DOSSIER
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { Adv, Error } from '@/mixins'
import { concat } from 'lodash'

export default {
  name: 'EspceAcquereur',
  components: {
    AdvBuyerSpaceInvitation: () => import('./AdvBuyerSpaceInvitation'),
    AdvBuyerSpaceTimeline: () => import('./AdvBuyerSpaceTimeline'),
    AdvBuyerSpaceDocs: () => import('./AdvBuyerSpaceDocs')
  },
  mixins: [Adv, Error],
  data () {
    return {
      timelineAdv: [],
      timelineProgram: [],
      panel: 'INVITATION',
      has_buyer_space: false,
      buyer_space_id: null,
      invitationMessage: null,
      buyerSpaceBuyers: [],
      fromCreated: true
    }
  },
  computed: {
    timeline () {
      return concat(this.timelineAdv, this.timelineProgram)
    }
  },
  watch: {
    'has_buyer_space' (to, old) {
      if (this.fromCreated) return
      if (to === false && old === true) {
        this.deleteBuyerSpace()
      } else if (to === true) {
        this.createBuyerSpace()
      }
    }
  },
  async created () {
    await this.initBuyerSpace()
    this.fromCreated = false
  },
  methods: {
    /**
       * remove event from timeline
       * @param {string} pk
       */
    sliceEvent (pk) {
      let idx = this.timelineAdv.findIndex(x => {
        return x.pk === pk
      })
      if (idx >= 0) {
        this.timelineAdv.splice(idx, 1)
      }
    },
    updateTimeline (idx, results) {
      if (idx >= 0) {
        this.timelineAdv.splice(idx, 1, results)
      } else {
        this.timelineAdv.push(results)
      }
    },
    /**
       * init buyer space
       * and get timeline
       */
    initBuyerSpace () {
      this.invitationMessage = this.adv.buyer_space_invitation_message || null
      if (this.adv.buyer_space_id) {
        this.has_buyer_space = true
        this.buyer_space_id = this.adv.buyer_space_id
        this.getBuyerSpaceBuyers()
      }
      this.getTimeLineAdv()
      this.getTimeLineProgram()
    },
    /**
       * get buyer space buyers (last login)
       */
    async getBuyerSpaceBuyers () {
      try {
        let { data } = await this.$api.get(`/reservations/${this.advPk}/buyer-space`)
        this.buyerSpaceBuyers = data.buyer_space_buyers || []
      } catch (err) {
        this.handleError(err)
        console.log(err)
      }
    },
    /**
       * get adv timeline
       */
    async getTimeLineAdv () {
      try {
        let { data } = await this.$api.get(`/reservations/${this.advPk}/timeline`)
        for (let timeline of data.items) {
          this.timelineAdv.push({
            from: 'adv',
            created_on: timeline.created_on,
            date: timeline.date,
            description: timeline.description,
            documents: timeline.documents,
            name: timeline.name,
            pictures: timeline.pictures,
            pk: timeline.pk,
            protected: timeline.protected
          })
        }
      } catch (err) {
        this.handleError(err)
        console.log(err)
      }
    },
    /**
       * get programm timeline
       */
    async getTimeLineProgram () {
      try {
        let { data } = await this.$api.get(`/programs/${this.adv.program.pk}/timeline`)
        for (let timeline of data.items) {
          this.timelineProgram.push({
            from: 'program',
            from_pk: this.adv.program.pk,
            created_on: timeline.created_on,
            date: timeline.date,
            description: timeline.description,
            documents: timeline.documents,
            name: timeline.name,
            pictures: timeline.pictures,
            pk: timeline.pk,
            protected: timeline.protected
          })
        }
      } catch (err) {
        this.handleError(err)
        console.log(err)
      }
    },
    /**
       * create buyer space
       */
    async createBuyerSpace () {
      try {
        let { data } = await this.$api.post(`/reservations/${this.advPk}/buyer-space`)
        this.$store.commit('modifyCurrentAdv', { key: `buyer_space_id`, value: data.buyer_space_id })
        this.updateAdv()
        this.buyer_space_id = data.buyer_space_id
        this.getBuyerSpaceBuyers()
      } catch (err) {
        this.handleError(err)
        console.log(err)
      }
    },
    /**
       * delete buyer space
       */
    async deleteBuyerSpace () {
      try {
        await this.$api.axios.delete(`/reservations/${this.advPk}/buyer-space`)
        this.$store.commit('modifyCurrentAdv', { key: `buyer_space_id`, value: null })
        this.updateAdv()
        this.buyer_space_id = null
        this.buyerSpaceBuyers = []
      } catch (err) {
        this.handleError(err)
        console.log(err)
      }
    }
  }
}
</script>
